import { useRouter } from 'next/router';

import { cookieStorage } from '../services';

const usePayPerClick = () => {
  const router = useRouter();

  const hasWkAtribute = () => {
    const hasWk = Object.hasOwn(router.query, 'wk');
    if (hasWk) {
      return router.query.wk === '1';
    }
    return false;
  };

  const setPayPerClickCookies = async () => {
    try {
      void cookieStorage.put({ key: 'wk', value: 'true' });

      const visitedPages = await cookieStorage.get('react_user_unique_page');

      if (visitedPages.data) {
        void cookieStorage.put({
          key: 'react_user_unique_page',
          value: (parseInt(visitedPages.data, 10) + 1).toString(),
        });
      } else {
        void cookieStorage.put({ key: 'react_user_unique_page', value: '0' });
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  const handlePayPerClick = async () => {
    if (hasWkAtribute()) {
      void setPayPerClickCookies();
    }
  };

  return { handlePayPerClick };
};

export default usePayPerClick;
